import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { WheelPrintView } from "~/components/wheel/results/print-view";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute(
  "/_public/wheel-of-life/results/$id_/print",
)({
  loader: async ({ params }) => {
    const { getWheelSessionFn, resolveWheelSuggestionsFn } =
      await import("~/lib/functions/wheel");
    const row = await getWheelSessionFn({ data: { id: params.id } });
    if (!row) throw notFound();
    // A coach session prints under its coach's name while that page is on.
    if (row.coachUsername) {
      throw redirect({
        to: "/$username/wheel-of-life/results/$id/print",
        params: { username: row.coachUsername, id: params.id },
        statusCode: 302,
      });
    }
    const resolved = await resolveWheelSuggestionsFn({
      data: { suggestions: row.suggestions ?? [] },
    });
    return { session: row, resolved };
  },
  staticData: { title: "Wheel of Life — Print" },
  head: () =>
    createNoIndexMeta(
      "Wheel of Life — Print",
      "Printable view of your Wheel of Life results.",
    ),
  component: PrintPage,
});

function PrintPage() {
  const { session, resolved } = Route.useLoaderData();
  const params = Route.useParams();
  return (
    <WheelPrintView
      id={params.id}
      session={session}
      header="Dream Coach Match — wheel of life"
      qrCaption="See your live results and matched coaches at"
      nextSteps={resolved.map((s) => ({
        key: `${s.cihItemType}-${s.cihItemId}`,
        categoryIndex: s.categoryIndex,
        title: s.title,
      }))}
    />
  );
}
